import { CORPUS_STATS } from './corpusStats';

/**
 * Stats ledger strip — one slot per specialization, so the strip itself says
 * "criminal AND civil AND corporate" (it used to be criminal-skewed: two of
 * four slots were BNS/IPC).
 *
 * Numbers + provenance live in corpusStats.ts — the SAME array feeds the hero
 * proof ribbon, so the two renderings can never drift. Re-verify there before
 * changing anything. (The SC figure also appears in SearchesBand's
 * case-search row.)
 */

/**
 * The living-library strip: in-progress acts named WITHOUT dates (roadmap
 * doctrine: no ETAs we can't hold), and the amendment-tracking promise backed
 * by the mechanism (every act versioned "as amended upto" in act_registry)
 * and by demonstrated behaviour (the 2023 codes re-index + 570 IPC mappings)
 * rather than by assertion.
 */
const PULSE = [
  {
    label: 'IN INDEXING NOW',
    text: 'Contract Act · Negotiable Instruments · CPC Orders — the civil shelf keeps growing.',
  },
  {
    label: 'ACT CHANGES, TRACKED',
    text: 'Every act is versioned “as amended upto” and re-stamped when the law moves — the same discipline that indexed the 2023 codes and cross-mapped all 570 IPC sections.',
  },
];

export default function StatsLedger() {
  return (
    <section
      id="research"
      className="grid grid-cols-2 lg:grid-cols-4 border-t border-brass-hairline"
    >
      {CORPUS_STATS.map((stat) => (
        <div
          key={stat.label}
          className="px-5 sm:px-8 lg:px-10 py-8 border-r border-brass-hairline-faint"
        >
          <div className="font-display text-3xl sm:text-[40px] leading-none text-parchment">
            {stat.value}
          </div>
          <div className="font-plex text-[11px] font-medium tracking-[0.2em] text-chamber-muted-faint mt-1.5">
            {stat.label}
          </div>
        </div>
      ))}

      {/* Living-library strip — spans the full grid width. */}
      <div className="col-span-2 lg:col-span-4 grid lg:grid-cols-2 border-t border-brass-hairline-faint">
        {PULSE.map((item) => (
          <div
            key={item.label}
            className="px-5 sm:px-8 lg:px-10 py-5 border-r border-brass-hairline-faint flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-5"
          >
            <span className="font-plex text-[10.5px] font-medium tracking-[0.24em] text-brass whitespace-nowrap">
              {item.label}
            </span>
            <span className="text-[13px] leading-[1.6] text-chamber-muted-dim">
              {item.text}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
